import { render, staticRenderFns } from "./RouterMenu.vue?vue&type=template&id=21f1b9e8&scoped=true"
import script from "./RouterMenu.vue?vue&type=script&lang=js"
export * from "./RouterMenu.vue?vue&type=script&lang=js"
import style0 from "./RouterMenu.vue?vue&type=style&index=0&id=21f1b9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f1b9e8",
  null
  
)

export default component.exports